import script from "./ListaInscritos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaInscritos.vue?vue&type=script&setup=true&lang=js"

import "./ListaInscritos.vue?vue&type=style&index=0&id=7a2dd8e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2dd8e0"]])

export default __exports__